import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, query, where, deleteDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import { Resource } from '../../types';
import { Plus, Trash2, FileText } from 'lucide-react';

export const ResourceManager: React.FC = () => {
  const [resources, setResources] = useState<Resource[]>([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const [category, setCategory] = useState('');

  useEffect(() => {
    fetchResources();
  }, []);

  const fetchResources = async () => {
    // For demo purposes, we fetch all resources. In production, we'd filter by tenantId.
    const q = collection(db, 'resources');
    const snapshot = await getDocs(q);
    setResources(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Resource)));
  };

  const handleAdd = async () => {
    if (!title || !fileUrl) return;
    await addDoc(collection(db, 'resources'), {
      title,
      description,
      fileUrl,
      category,
      createdAt: serverTimestamp(),
      tenantId: 'default' // Placeholder tenant
    });
    setTitle('');
    setDescription('');
    setFileUrl('');
    setCategory('');
    fetchResources();
  };

  const handleDelete = async (id: string) => {
    await deleteDoc(doc(db, 'resources', id));
    fetchResources();
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow">
      <h2 className="text-xl font-bold mb-4">Manage Resources</h2>
      <div className="space-y-4 mb-8">
        <input placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} className="w-full p-2 border rounded" />
        <input placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} className="w-full p-2 border rounded" />
        <input placeholder="File URL" value={fileUrl} onChange={e => setFileUrl(e.target.value)} className="w-full p-2 border rounded" />
        <input placeholder="Category" value={category} onChange={e => setCategory(e.target.value)} className="w-full p-2 border rounded" />
        <button onClick={handleAdd} className="bg-emerald-600 text-white px-4 py-2 rounded flex items-center gap-2">
          <Plus size={16} /> Add Resource
        </button>
      </div>

      <div className="space-y-2">
        {resources.map(res => (
          <div key={res.id} className="flex justify-between items-center p-3 border rounded">
            <div className="flex items-center gap-3">
              <FileText className="text-gray-400" />
              <div>
                <p className="font-bold">{res.title}</p>
                <p className="text-sm text-gray-500">{res.description}</p>
              </div>
            </div>
            <button onClick={() => handleDelete(res.id!)} className="text-red-600">
              <Trash2 size={16} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
